import { SET_PRODUTO, SET_LOADING } from './mutation-types'
import objectHelper from '@/helpers/object.helper'

export default {
    [SET_PRODUTO](state, payload) {
        state.produto = objectHelper.copy(payload)
    },
    [SET_LOADING](state, payload) {
        state.loading = payload
    }
}